import { DEPLOYMENT_URL } from "@shared/constants";
import { DeploymentRepoListResponse } from "@shared/types";

import { authGet } from "../auth/auth";

export const fetchDeploymentRepos = (
  deploymentId: number,
  codeAccess: boolean = false
): Promise<DeploymentRepoListResponse> => {
  let url = `${DEPLOYMENT_URL}/${deploymentId}/repos`;
  if (codeAccess) {
    url = `${url}?code_access=1`;
  }
  return authGet<DeploymentRepoListResponse>(url);
};
